import Phaser from 'phaser';
import { eventBus } from '@/shared/EventBus';

/**
 * Łączy wejście z dwóch źródeł:
 *  - klawiatura (WASD + strzałki) — desktop
 *  - wirtualny joystick przez EventBus — mobile
 *
 * Wektor wynikowy jest znormalizowany (długość ≤ 1).
 * Jeśli oba źródła są aktywne, sumują się i są clamp'owane do 1.
 */
export class InputSystem {
  private joystick = { dx: 0, dy: 0 };
  private keys!: {
    W: Phaser.Input.Keyboard.Key;
    A: Phaser.Input.Keyboard.Key;
    S: Phaser.Input.Keyboard.Key;
    D: Phaser.Input.Keyboard.Key;
    UP: Phaser.Input.Keyboard.Key;
    DOWN: Phaser.Input.Keyboard.Key;
    LEFT: Phaser.Input.Keyboard.Key;
    RIGHT: Phaser.Input.Keyboard.Key;
  };
  private detachJoystick: (() => void) | null = null;

  attach(scene: Phaser.Scene): void {
    if (!scene.input.keyboard) {
      console.warn('[InputSystem] Brak keyboard plugin — pomijam WASD.');
    } else {
      const KC = Phaser.Input.Keyboard.KeyCodes;
      this.keys = {
        W: scene.input.keyboard.addKey(KC.W),
        A: scene.input.keyboard.addKey(KC.A),
        S: scene.input.keyboard.addKey(KC.S),
        D: scene.input.keyboard.addKey(KC.D),
        UP: scene.input.keyboard.addKey(KC.UP),
        DOWN: scene.input.keyboard.addKey(KC.DOWN),
        LEFT: scene.input.keyboard.addKey(KC.LEFT),
        RIGHT: scene.input.keyboard.addKey(KC.RIGHT),
      };
    }
    this.detachJoystick = eventBus.on('input:joystick', (e) => {
      this.joystick.dx = e.dx;
      this.joystick.dy = e.dy;
    });
  }

  detach(): void {
    this.detachJoystick?.();
    this.detachJoystick = null;
    this.joystick = { dx: 0, dy: 0 };
  }

  /** Wektor ruchu w aktualnej klatce. Długość ∈ [0, 1]. */
  getMovement(): { x: number; y: number } {
    let x = this.joystick.dx;
    let y = this.joystick.dy;

    if (this.keys) {
      if (this.keys.A.isDown || this.keys.LEFT.isDown) x -= 1;
      if (this.keys.D.isDown || this.keys.RIGHT.isDown) x += 1;
      if (this.keys.W.isDown || this.keys.UP.isDown) y -= 1;
      if (this.keys.S.isDown || this.keys.DOWN.isDown) y += 1;
    }

    const len = Math.hypot(x, y);
    if (len > 1) {
      x /= len;
      y /= len;
    }
    return { x, y };
  }
}
